import HeaderOutdoor from "./components/HeaderOutdoor";

if (!window.customElements.get("arcteryx-outdoor-header")) {
  window.customElements.define("arcteryx-outdoor-header", HeaderOutdoor);
}
